import React, { useEffect, useState } from "react";
import TitleComponent from "../../../global/Custom/TitleComponent/TitleComponent";
import { EditOutlined } from "@ant-design/icons";
import { Card, Col, Row, Empty, Button, Modal, Form, Input, message } from "antd";
import { dispatch, useSelector } from "../../../redux/store";
import Loading from "../../../global/item/Loading/loading";
import { useTranslation } from "react-i18next";
import { getOtherType, updateOtherType } from "../../../redux/action/otherType";
import { Category_Policy } from "../../../utils/formatType";
import { OtherType } from "../../../@type/otherType";

function PolicyCategory() {
  const { t } = useTranslation();
  const { otherTypeList } = useSelector((state) => state.otherType);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<OtherType | null>(null);
  const [form] = Form.useForm();

  // 🔹 Load danh sách ban đầu
  useEffect(() => {
    dispatch(getOtherType(Category_Policy))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, []);

  // 🔹 Mở modal & set giá trị form
  const handleEditClick = (item: OtherType) => {
    setSelectedItem(item);
    form.setFieldsValue({
      title: item.title,
      description: item.description,
    });
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
    form.resetFields();
  };

  // 🔹 Gọi update API
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (!selectedItem) return;

      await dispatch(
        updateOtherType({
          id: Number(selectedItem.id),
          a: {
            title: values.title,
            description: values.description,
            type: Category_Policy,
          },
        })
      );

      message.success("Cập nhật thành công 🎉");
      await dispatch(getOtherType(Category_Policy));

      setIsModalOpen(false);
      setSelectedItem(null);
    } catch (err) {
      console.error(err);
      message.error("Cập nhật thất bại ❌");
    }
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <TitleComponent
            title={"Chính sách"}
            type="primary"
            isExist={true}
          />

          {otherTypeList?.length > 0 ? (
            <Row gutter={[16, 16]}>
              {otherTypeList.map((item: OtherType) => (
                <Col xs={24} sm={12} md={8} lg={8} key={item.id}>
                  <Card
                    hoverable
                    className="layoutItem"
                    style={{ borderRadius: 10 }}
                    actions={[
                      <Button
                        key="edit"
                        type="text"
                        icon={<EditOutlined />}
                        onClick={() => handleEditClick(item)}
                      >
                        {t("edit") || "Chỉnh sửa"}
                      </Button>,
                    ]}
                  >
                    <h3
                      style={{
                        color: "var(--primary-color)",
                        fontSize: 16,
                        marginBottom: 6,
                      }}
                    >
                      {item.title}
                    </h3>
                    <p
                      style={{
                        fontSize: 14,
                        color: "#555",
                        minHeight: 60,
                      }}
                    >
                      {item.description || t("noDescription")}
                    </p>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <Empty description={t("noData") || "Không có dữ liệu"} />
          )}

          {/* 🧩 Modal chỉnh sửa */}
          <Modal
            title="Chỉnh sửa lý do"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Lưu thay đổi"
            cancelText="Hủy"
            destroyOnClose
          >
            <Form form={form} layout="vertical">
              <Form.Item
                label="Tiêu đề"
                name="title"
                rules={[{ required: true, message: "Vui lòng nhập tiêu đề" }]}
              >
                <Input placeholder="Nhập tiêu đề" />
              </Form.Item>

              <Form.Item label="Mô tả" name="description">
                <Input.TextArea rows={4} placeholder="Nhập mô tả" />
              </Form.Item>
            </Form>
          </Modal>
        </div>
      )}
    </div>
  );
}

export default PolicyCategory;
